import React, { useContext } from 'react';
import { Common } from '../../static/Messages';
import DataCard from '../dataCard/DataCard';
import { MessageContext } from '../../locale/MessageProvider';
import { Button } from 'is24-corecss';

type DataAccessProps = {
  onEdit: () => void;
  className?: string;
};

enum fieldName {
  title,
}

const DataAccess: React.FC<DataAccessProps> = ({ onEdit, className }: DataAccessProps) => {
  const messageFormatter = useContext(MessageContext);

  return (
    <DataCard
      title={messageFormatter.formatMessage(DataAccess, fieldName[fieldName.title])}
      className={className}
      button={
        <Button data-testid="data-card-button-data-access" textStyle={true} onClick={onEdit}>
          <span className="is24-icon-edit "></span>
          {' ' + messageFormatter.formatCommonMessage(Common.edit).toLowerCase()}
        </Button>
      }
    ></DataCard>
  );
};

export default DataAccess;
